import React, {lazy, Suspense} from 'react'

const RetreatLazy = lazy(() =>
    import('./Retreat')
)

const Retreat = props => (
    <Suspense fallback={null}>
        <RetreatLazy {...props} />
    </Suspense>
)

export default Retreat
